import { useEffect, useState } from "react";
import { useRootStore } from "../hooks/useRootStore";
import { Link, List, ListItem } from "@mui/material";
import { Client } from "../data/Client";
import { DataGrid, GridColDef } from "@mui/x-data-grid";
import { Project } from "../data/Project";

export default function ClientList() {
    const { api } = useRootStore();

    const [loading, setLoading] = useState(true);
    const [clients, setClients] = useState([]as Client[]);

    useEffect(() => {
        api.getClients().then(e => {
            setClients(e);
            setLoading(false);
        });

    }, [api]);

    const columns: GridColDef[] = [
        { field: 'ID', headerName: 'Название', width: 280, display: 'flex', renderCell: (params) => <Link href={`/clients/${params.value}`}>{params.row.Name}</Link> },        
        { field: 'ResponsibleEmployee', width: 350, display: 'flex', headerName: 'Ответственный', renderCell: (params) => params.value ? <Link href={`employees/${params.value.ID}`}>{params.value.Name}</Link> : '' },
        { field: 'Email', headerName: 'Email', width: 250, display: 'flex', renderCell: (params) => <Link href={`mailto://${params.value}`}>{params.value}</Link> },
        {
            field: 'Projects', headerName: 'Проекты', width: 450, renderCell: (params) => {
                return (
                    <List>
                        {(params.value as Project[]).map(x => <ListItem key={x.ID}><Link href={`/projects/${x.ID}`}>{x.Name}</Link></ListItem>)}
                    </List>
                )
            }
        },
    ];

    return (
        loading ? 'Загрузка' :
            <>
                <h2>Наши клиенты</h2>
                <DataGrid
                    rows={clients}
                    hideFooter={clients.length <= 100}
                    getRowHeight={() => 'auto'}
                    getRowId={(row) => row.ID}
                    columns={columns}
                    //initialState={{ pagination: { paginationModel } }}
                    //pageSizeOptions={[5, 10]}
                    // checkboxSelection
                    sx={{ border: 0, m:5 }}
                />
            </>
    );
}